import { Component, inject, input, OnDestroy, OnInit, output } from '@angular/core';
import { RidSentenceReadingBase } from '../../components/rid-sentence-reading-base/rid-sentence-reading-base';
import { RidSentence } from '../../components/rid-sentence/rid-sentence';
import { ExpressionService } from '../../services/expression-service.service';

@Component({
  selector: 'rid-sentence-reading',
  imports: [RidSentenceReadingBase],
  templateUrl: './rid-sentence-reading.html',
  host: {
    class: 'block',
  },
})
export class RidSentenceReading implements OnInit, OnDestroy {
  private readonly $expressionService = inject(ExpressionService);

  sentencesMatrix = input.required<string[][]>();
  pace = input.required<number>();

  finished = output<void>();

  ngOnInit(): void {
    this.$expressionService.setAvailability('CLIENT', true);
  }

  ngOnDestroy(): void {
    this.$expressionService.setAvailability('CLIENT', false);
  }

  async doSentencePass(sentence: RidSentence, pace: number): Promise<void> {
    await sentence.pass(pace, { opacity: 1, scale: 1 }, { opacity: 1, scale: 1 });
  }
}
